import { mainStore, windowsIndex } from "./mainStore";
import { getPreloads } from "./preloads";
import { getOrCreateMainLogger } from "../logger/main";
import { IpcMainEvent } from "electron";

const logger = getOrCreateMainLogger();

const getWebContentsIdFromWindowName = (windowName?: string) => {
	const requestedMainWindow = windowName ? windowsIndex.byWindowName[windowName] : null;
	return requestedMainWindow?.webContentsId;
};

/**
 * Fetches a window's identity from the mainStore and returns it along with
 * preloads synchronously (`event.returnValue`) back to the e2o.ts preload.
 */
export const getWindowIdentity = (event: IpcMainEvent): void => {
	const { id } = event.sender;
	const identity = mainStore.webContents[id];
	const err = identity ? null : `Window identity not found for ${id}`;

	if (err) logger.error(err);
	const { data: preloads } = getPreloads(id);

	const identityWithPreloadSrc = {
		...identity,
		preloads: preloads ?? [],
	};
	event.returnValue = {
		err,
		data: identityWithPreloadSrc,
	};
};

/**
 * Fetches a window's identity given a windowName and returns it
 * synchronously (`event.returnValue`). This is used when a "wrap" is being requested.
 */
export const getWindowIdentityForWindowName = (event: IpcMainEvent, windowName: string): void => {
	const maybeRequestedID = getWebContentsIdFromWindowName(windowName);
	if (!maybeRequestedID) {
		const err = `Window identity not found. No WebContents for window "${windowName}"`;
		logger.error(err);
		event.returnValue = {
			err,
		};
		return;
	}
	const identity = mainStore.webContents[maybeRequestedID];
	if (!identity) {
		const err = `Window identity not found for ${windowName}`;
		logger.error(err);
		event.returnValue = {
			err,
		};
		return;
	}
	event.returnValue = {
		data: identity,
	};
};
